import { IFileHeaderData } from '@common/interfaces/file'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import { IAction } from '../apiMiddleware'
import * as actions from './actions'

export default combineReducers({
  loadingArray(state: string[] = [], action: IAction): string[] {
    switch (action.type) {
      case actions.UPLOAD_REQUEST:
      case actions.UPDATE_REQUEST:
      case actions.DELETE_REQUEST:
        return [...state, action.type]
      case actions.UPLOAD_SUCCESS:
      case actions.UPLOAD_FAILURE:
      case actions.UPDATE_SUCCESS:
      case actions.UPDATE_FAILURE:
      case actions.DELETE_SUCCESS:
      case actions.DELETE_FAILURE:
        return state.filter(
          (item) =>
            item !== action.type.replace('SUCCESS', 'REQUEST').replace('FAILURE', 'REQUEST'),
        )
      default:
        return state
    }
  },
  headerMappings: createLoadingDataReducer<IFileHeaderData>(
    [actions.LIST_HEADER_MAPPING_REQUEST],
    [actions.UPDATE_HEADER_MAPPING_REQUEST, actions.CREATE_HEADER_MAPPING_SUCCESS],
    true,
    [actions.RESET_HEADER_MAPPING],
  ),
})
